import type { SubtitleBlock as SubtitleBlockType } from '@/payload-types'
import type { SerializedBlockNode } from '@payloadcms/richtext-lexical'
import type { JSXConverter } from '@payloadcms/richtext-lexical/react'
import SubTitleBlock from '../blocks/SubTitleBlock'

export const SubtitleConverter: JSXConverter<SerializedBlockNode<SubtitleBlockType>> = ({
	node,
}) => {
	const { text } = node.fields

	return <SubTitleBlock subTitle={text} />
}
